/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/30
 */
import EventEmitter from 'events';

class ScrollInView extends EventEmitter {
  constructor (node, beforeInAndRemove) {
    super();
    this.node = node;
    this.beforeInAndRemove = beforeInAndRemove || false;
    this.requestScroll();
    this.bindRequestScroll = this.requestScroll.bind(this);
    window.addEventListener('scroll', this.bindRequestScroll);
    window.addEventListener('resize', this.bindRequestScroll);
  }
  requestScroll () {
    this.prevLoc = this.getLoc();
    this.requestFrame()
  }
  getLoc () {
    return window.scrollY || window.pageYOffset;
  }
  requestFrame () {
    if (!this.ticking) {
      window.requestAnimationFrame(this.check.bind(this));
      this.ticking = true;
    }
  }
  getOffset (node) {
    return node.getBoundingClientRect().top + this.prevLoc;
  }
  inViewport (node) {
    const viewBot = this.prevLoc + this.windowHeight;

    const nodeTop = this.getOffset(node);
    const nodeBot = nodeTop + node.offsetHeight;

    return (nodeBot >= this.prevLoc) && (nodeTop <= viewBot);
  }
  check () {
    this.windowHeight = window.innerHeight;
    if (!this.node) {
      return this.removeListener();
    }
    if (this.inViewport(this.node)) {
      this.emit('in');
      this.beforeInAndRemove && this.removeListener();
    }

    this.ticking = false;
    return this
  }
  removeListener () {
    if (this.removed) {
      return this;
    }
    this.removed = true;
    window.removeEventListener('scroll', this.bindRequestScroll);
    window.removeEventListener('resize', this.bindRequestScroll);
  }
}

export default ScrollInView;



// WEBPACK FOOTER //
// ./src/utils/scrollInView.js